import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/macys-logo.svg";
import SigninIcon from "../assets/images/signin.png";
import LoadingOverlay from "react-loading-overlay";
import * as Constants from "../constants/Constants";
import "./Signin.css";
import DocumentLibraryUpdates from "./DocumentLibrary/DocumentLibraryUpdates";
import { LicenseManager } from "ag-grid-enterprise";
import { httpGetPublicUIEnv } from "../service/httpClient";

export const signinNavList = [
  {
    navName: Constants.DOCUMENT_LIBRARY_TITLE,
    navLink: "/document-library",
    navLinkIdentifier: "documentLibrary",
    navId: "document-library",
  },
];

const Login = () => {
  const [isLoading, setIsLoading] = useState(true);
  const handleInternalRedirect = () => {
    window.location = "/login";
  };
  const verifyMenuItemAccess = (navId) => {
    if (navId === "document-library") {
      return Constants.ENABLE_DOC_LIBRARY === Constants.DISABLED_FLAG
        ? false
        : true;
    }
    return true;
  };
  const getPublicEnv = () => {
    return httpGetPublicUIEnv()
      .then((res) => {
        LicenseManager.setLicenseKey(res.data.AGGRID_LICENSE_KEY);
        return res.data;
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    getPublicEnv()
      .then((uiEnv) => {
        if (uiEnv !== "undefined") {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(Constants.GET_ENV_ERR_MSG);
      });
  }, []);

  return (
    <div className="login-main-container">
      <div className="login-header">
        <div className="login-top-nav cls-link">
          {signinNavList.map((nav, i) => {
            if (verifyMenuItemAccess(nav.navId)) {
              return (
                <Link
                  id={nav.navId}
                  to={nav.navLink}
                  style={{ marginRight: 30 }}
                  key={`${i}-${nav.navId}`}
                >
                  {nav.navName}
                </Link>
              );
            }
          })}
        </div>
      </div>
      <div className="login-mid-container">
        <div className="login-mid-left">
          <span className="dl-heading d-flex align-items-center justify-content-center">
            {Constants.SIGNIN_DOC_LIB_TXT}
          </span>
          <LoadingOverlay active={isLoading} spinner>
            <DocumentLibraryUpdates isListView={true} />
          </LoadingOverlay>
        </div>
        <div className="login-mid-line">
          <div className="vert-line"></div>
        </div>
        <div className="login-mid-right">
          <div className="login-mid-logo d-flex align-items-center justify-content-center">
            <img
              src={Logo}
              id="imgLogo"
              alt="logo"
              className={`Login-signInMacysLogo`}
            />
          </div>
          <div className="login-mid-logo-txt d-flex align-items-center justify-content-center">
            {Constants.SIGNIN_APP_TITLE}
          </div>
          <div className="login-mid-signin-btn d-flex align-items-center justify-content-center">
            <button
              id="logonBtn"
              className={`login-btn`}
              onClick={handleInternalRedirect}
              type="submit"
            >
              {Constants.SIGNIN_BTN_TXT} &nbsp;
              <img src={SigninIcon} className={""} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
